import MyPage from "@/views/mypage/MyPage.vue";
import OrderListPage from "@/views/mypage/myShopping/OrderListPage.vue";
import CancelListPage from "@/views/mypage/myShopping/CancelListPage.vue";
import AccountManagementPage from "@/views/mypage/myShopping/AccountManagementPage.vue";
import InquiryListPage from "@/views/mypage/activityLog/InquiryListPage.vue";
import MyReviewPage from "@/views/mypage/activityLog/MyReviewPage.vue";
import EditPofilePage from "@/views/mypage/privacyManagement/EditPofilePage.vue";
import ChangePwdPage from "@/views/mypage/privacyManagement/ChangePwdPage.vue";
import SnsConnectionSettingPage from "@/views/mypage/privacyManagement/SnsConnectionSettingPage.vue";
import DeleteAccountPage from "@/views/mypage/privacyManagement/DeleteAccountPage.vue";

const mypageRoutes = [
  {
    path: "/mypage",
    children: [
      {
        path: "recent-order",
        name: "MyPage",
        component: MyPage,
        meta: { requiresAuth: true }
      },
      {
        path: "order-list",
        name: "OrderListPage",
        component: OrderListPage,
        meta: { 
          requiresAuth: true,
          normalOnly: true,
        }
      },
      {
        path: "cancel-list",
        name: "CancelListPage",
        component: CancelListPage,
        meta: { 
          requiresAuth: true,
          normalOnly: true,
        }
      },
      {
        path: "account-management",
        name: "AccountManagementPage",
        component: AccountManagementPage,
        meta: { 
          requiresAuth: true,
          normalOnly: true,
        }
      },
      {
        path: "inquiry-list",
        name: "InquiryListPage",
        component: InquiryListPage,
        meta: { 
          requiresAuth: true,
          normalOnly: true,
        }
      },
      {
        path: "my-review",
        name: "MyReviewPage",
        component: MyReviewPage,
        meta: { 
          requiresAuth: true,
          normalOnly: true,
        }
      },
      {
        path: "edit-profile",
        name: "EditPofilePage",
        component: EditPofilePage,
        meta: { 
          requiresAuth: true,
          normalOnly: true,
        }
      },
      {
        path: "change-pwd",
        name: "ChangePwdPage",
        component: ChangePwdPage,
        meta: { 
          requiresAuth: true,
          normalOnly: true,
        }
      },
      {
        path: "sns-connection-setting",
        name: "SnsConnectionSettingPage",
        component: SnsConnectionSettingPage,
        meta: { 
          requiresAuth: true,
          normalOnly: true,
        }
      },
      {
        path: "delete-account",
        name: "DeleteAccountPage",
        component: DeleteAccountPage,
        meta: { 
          requiresAuth: true,
          normalOnly: true,
        }
      },
    ]
  }
]

export default mypageRoutes;